import React from 'react';
import logoCoop from '../../img/frasecoop.png';
import styles from './NavBar.module.css';
import coopnav from '../../img/coopnav.png';
import mcoop from '../../img/mcoopnavhead.png';

const NavBar = () => {
  return (
    <div className={styles.navContainer}>
      <div className={styles.homecontainer}>
        <a href="/coop">
          <button>
            <img src={coopnav} alt="" />
            <img src={coopnav} alt="" className={styles.btnm} />
          </button>
        </a>
      </div>
      <div className={styles.imgcontainer}>
        <img src={logoCoop} alt="" className={styles.logo}></img>
      </div>
    </div>
  );
};
export default NavBar;
